import { render, staticRenderFns } from "./BasicTestimonial.vue?vue&type=template&id=6d1826d9"
import script from "./BasicTestimonial.vue?vue&type=script&lang=js"
export * from "./BasicTestimonial.vue?vue&type=script&lang=js"
import style0 from "./BasicTestimonial.vue?vue&type=style&index=0&id=6d1826d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports